import { InjectionToken } from "@angular/core";

export const API_URL = new InjectionToken<string>('API.URL');

export const ARENA_EQ_APP = new InjectionToken<string>('ARENA_EQ_APP');